import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_VDPopupListbox = _resolveComponent("VDPopupListbox")!

  return (_openBlock(), _createBlock(_component_VDPopupListbox, {
    ref: "listbox",
    dataKey: ['applicationId'],
    filterFields: ['name', 'applicationId'],
    isLoading: _ctx.isApplicationOptionsLoading,
    options: _ctx.applicationOptions,
    disabledOptions: _ctx.selectedApplications,
    onOptionAdded: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('addedApplication', $event)))
  }, {
    default: _withCtx(({ option }) => [
      _createVNode("span", null, _toDisplayString(option.name), 1)
    ]),
    _: 1
  }, 8, ["isLoading", "options", "disabledOptions"]))
}